import styled from 'styled-components';

const StyledBannerNews = styled.div`
  position:relative;
  padding-bottom: ${ props => props.theme.components_spacing_desk.xxlarge}px;
  .banner-news--wrap{
    position: relative;
    width: 100%;
  }
  .banner-news--hero{
    position: relative;
    width: 100%;
  }
  .banner-news--hero-bg{
    position: relative;
    z-index: 1;
    width: 100%;
    height: auto;
    display: block;
  }
  .opacity-banner{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .banner-news--info{
    position: absolute;
    bottom: 0;
    padding-bottom: 82px;
    width: 66.66%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    color: #fff;
  }

  .banner-news--info .title{
    padding: 30px 0 24px;
  }
  .row-details{
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .col-details{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 24px;
  }
  .col-details img{
    margin-right: 8px;
  }
  .banner--news--cta-wrap{
    padding-top: ${ props => props.theme.components_spacing_desk.medium}px;
    width: 66.66%;
    margin: 0 auto;
  }
  .excerpt{
    padding-bottom: 24px;
  }
  @media screen and (max-width: 1439px){
   
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${ props => props.theme.components_spacing_tablet.xxlarge}px;

    .banner--news--cta-wrap{
      padding-top: ${ props => props.theme.components_spacing_tablet.medium}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-bottom: ${ props => props.theme.components_spacing_mobile.xxlarge}px;

    .banner-news--hero{
      height: 70vh;
    }
    .banner-news--hero-bg{
      height: 100%;
      width: auto;
      left: 50%;
      transform: translateX(-50%);
    }
    .banner-news--info{
      padding-bottom: 40px;
      width: calc(100% - 48px);
    }
    .banner-news--info .title{
      padding: 24px 0 16px;
    }
    .banner--news--cta-wrap{
      padding-top: ${ props => props.theme.components_spacing_mobile.medium}px;
      padding-left: 24px;
      padding-right: 24px;
      width: auto;
    }
    .excerpt{
      padding-bottom: 16px;
    }
  }
`;

export {
  StyledBannerNews,
};

